// extracted by mini-css-extract-plugin
export default {"currentPlanLabel":"xKXDYQOCaujudnwovTfH","dropdownMenu":"F3jREjs7wPEJxlt9HNKE"};